<template>
    <div class="setup-case">
        <Row class="detail-header">
            <span>立案</span>
            <Row style="float:right;">
                <Button v-if="infoCtrl&&isDetailLoad" type="primary" @click="getDetail('edit')">修改</Button>
            </Row>
        </Row>
        <Row class="case-content">
            <Form ref="formValidate" class="case-form" v-if="!infoCtrl&&isDetailLoad" :model="formValidate" :rules="ruleValidate" :label-width="100">
                <FormItem label="报案日期" prop="reportDate">
                    <DatePicker 
                        transfer 
                        type="date" 
                        placeholder="请选择报案日期" 
                        style="width:100%" 
                        format="yyyy-MM-dd" 
                        :value="formValidate.reportDate"
                        @on-change="getValue"></DatePicker>
                </FormItem>
                <FormItem label="受理机关" prop="unit">
                    <Input v-model="formValidate.unit" placeholder="请输入受理机关"/>
                </FormItem>
                <Row>
                    <Col span="10">
                        <FormItem label="办案人" prop="principal">
                            <Input v-model="formValidate.principal" placeholder="姓名"></Input>
                        </FormItem>
                    </Col>
                    <Col span="7">
                        <FormItem :label-width="10" prop="position">
                            <Input v-model="formValidate.position" placeholder="职务"></Input>
                        </FormItem>
                    </Col>
                    <Col span="7">
                        <FormItem :label-width="10" prop="phone" :rules="formValidate.phone?isCorrectPhone:{}">
                            <Input v-model="formValidate.phone" placeholder="电话"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <FormItem label="办案材料" prop="attachmentList">
                    <file-upload
                        :defaultList="defaultList || []" 
                        :uploadConfig="{}"
                        @getFileList="getAttachmentList($event,'attachmentList')"></file-upload>
                </FormItem>
                <Row class="detail-btn-box">
                    <Button type="primary" style="margin-right:10px;" :disabled="isSubmit" @click="submitNew">保存</Button>
                    <Button v-if="defaultData" @click="infoCtrl=true">取消</Button>
                </Row>
            </Form>
            <Row class="detail-content" v-if="infoCtrl&&isDetailLoad">
                <Row><Col span="5" class="left-label">报案日期：</Col><Col span="16" class="right-content">{{defaultData.reportDate || ""}}</Col></Row>
                <Row><Col span="5" class="left-label">受理机关：</Col><Col span="16" class="right-content">{{defaultData.unit || ""}}</Col></Row>
                <Row><Col span="5" class="left-label">办案人：</Col><Col span="16" class="right-content">{{defaultData.principal || ""}}--{{defaultData.position || ""}}--{{defaultData.phone || ""}}</Col></Row>
                <Row>
                    <Col span="5" class="left-label">办案材料：</Col>
                    <Col span="16" class="right-content">
                        <file-upload
                            :defaultList="defaultData.attachmentList || []" 
                            :uploadConfig="{readOnly:true}"></file-upload>
                    </Col>
                </Row>
            </Row>
        </Row>
    </div>
</template>
<script>
export default {
    data () {
        const validateTelPhone = (rule ,value, callback) => {
            if(!(/^[1][3,4,5,7,8,9][0-9]{9}$/.test(value)) && !(/^(\d{3,4}-)\d{7,14}$/.test(value))){
                return callback (new Error('格式：0755-8888888(固话)1311111111(手机)'))
            }
            callback();
        }
        return {
            editId:'',
            isSubmit:false,
            infoCtrl:false,
            isDetailLoad:false,
            defaultData:"",
            defaultList:[],
            formValidate:{
                reportDate:"",
                unit:"",
                principal:"",
                position:"",
                phone:"",
                attachmentList:[]
            },
            ruleValidate:{
                reportDate:[{required: true, message: '报案不能为空', trigger: 'blur'}],
                unit:[{required: true, message: '受理机关不能为空', trigger: 'blur'},{ max:64,message:'不能超过64个字符',trigger:'blur' }],
                principal:[{ max:32,message:'不能超过32个字符',trigger:'blur' }],
                position:[{ max:32,message:'不能超过32个字符',trigger:'blur' }],
                attachmentList:[{required: true,type:'array', message: '办案材料不能为空', trigger: 'change'}]
            },
            isCorrectPhone:[{validator:validateTelPhone, trigger: 'blur' }],
        }
    },
    props: ['caseId','processId'],
    methods: {
        // 获取受理详情
        getDetail(type){
            let url = '/business/case/administrative/filing/'+this.processId;
            this.$get(url).then(res=>{
                if(res.code==0&&res.data){
                    this.defaultData = res.data;
                    this.infoCtrl = type==='edit'?false:true;
                    if(type==='edit'){
                        this.giveDefaultData(res.data);
                    }
                    this.isDetailLoad = true;
                }else{
                    this.defaultData = "";
                    this.infoCtrl = false;
                    this.isDetailLoad = true;
                }
            });
        },
        getValue(value){
            this.formValidate.reportDate = value;
        },
        getTime(arr){
            this.formValidate.proofStartTime = arr[0];
            this.formValidate.proofEndTime = arr[1];
        },
        //获取图片列表
        getAttachmentList (arr,key) {
            this.formValidate[key] = [];
            arr.forEach((item,index)=>{
                let obj = {
                    fileName:item.fileName,
                    mediaType:item.mediaType,
                    smallUrl:item.smallUrl,
                    url:item.url
                }
                this.formValidate[key].push(obj);
            })
        },
        submitNew(){
            let url = "/business/case/administrative/filing";
            let ajaxData = {
                processId:this.processId,
                caseId:this.caseId
            }
            Object.assign(ajaxData,this.formValidate);
            this.$refs['formValidate'].validate((valid) => {
                if(valid){
                    this.isSubmit = true;
                    if(this.defaultData){
                        ajaxData.id = this.editId;
                        this.$patch(url,ajaxData).then(res=>{
                            this.isSubmit = false;
                            if(res.code==0){
                                this.getDetail();
                                this.$Message.success("操作成功");
                                this.$emit('reloadProcess');
                            }else{
                                this.$Message.error(res.message);
                            }
                        })
                    }else{
                        this.$post(url,ajaxData).then(res=>{
                            this.isSubmit = false;
                            if(res.code==0){
                                this.getDetail();
                                this.$Message.success("操作成功");
                                this.$emit('reloadProcess');
                            }else{
                                this.$Message.error(res.message);
                            }
                        })
                    }
                }
            })
        },
        giveDefaultData(value){
            let data = JSON.parse(JSON.stringify(value))
            this.editId = data.id;
            for(let key in this.formValidate){
                this.formValidate[key] = data[key];
            }
            this.defaultList = data.attachmentList;
            this.isDetailLoad = true;
        }
    },
    created(){},
    beforeMount(){
        this.getDetail();
    },
    mounted(){},
    updated(){},
    components: {},
    watch: {}
}
</script>
<style scoped lang="scss">
@import '../../civilCase/caseCommon.scss';
</style>



// WEBPACK FOOTER //
// src/view/administrativeCase/setUpCase/index.vue